
import { useState } from 'react';

export interface PrayerVoice {
  id: string;  // Azure voice name
  name: string; // Display name
  description: string;
  gender: 'male' | 'female';
  style?: string; // Optional Azure voice style
  previewUrl: string;
}

// Azure voices with appropriate styles
export const PRAYER_VOICES: PrayerVoice[] = [
  {
    id: "en-US-FableTurboMultilingualNeural",
    name: "David",
    description: "Youthful & Passionate",
    gender: "male",
    style: "hopeful",
    previewUrl: "https://bbhhusjprzalcwvkgvsa.supabase.co/storage/v1/object/public/photos//David.MP3"
  },
  {
    id: "en-US-OnyxTurboMultilingualNeural",
    name: "James",
    description: "Mature & Reflective",
    gender: "male",
    style: "calm",
    previewUrl: "https://bbhhusjprzalcwvkgvsa.supabase.co/storage/v1/object/public/photos//James.MP3"
  },
  {
    id: "en-GB-OllieMultilingualNeural",
    name: "Solomon",
    description: "Wise & Compassionate",
    gender: "male",
    style: "narration-professional",
    previewUrl: "https://bbhhusjprzalcwvkgvsa.supabase.co/storage/v1/object/public/photos//Solomon.MP3"
  },
  {
    id: "en-US-CoraMultilingualNeural", 
    name: "Sarah",
    description: "Vibrant & Hopeful",
    gender: "female",
    style: "empathetic",
    previewUrl: "https://bbhhusjprzalcwvkgvsa.supabase.co/storage/v1/object/public/photos//Sarah.MP3"
  },
  {
    id: "en-US-ShimmerTurboMultilingualNeural",
    name: "Elizabeth",
    description: "Grounded & Empathetic",
    gender: "female",
    style: "hopeful",
    previewUrl: "https://bbhhusjprzalcwvkgvsa.supabase.co/storage/v1/object/public/photos//Elizabeth.MP3"
  },
  {
    id: "en-GB-AdaMultilingualNeural",
    name: "Ruth",
    description: "Gentle & Experienced",
    gender: "female",
    style: "calm",
    previewUrl: "https://bbhhusjprzalcwvkgvsa.supabase.co/storage/v1/object/public/photos//Ruth.MP3"
  }
];

export const usePrayerVoices = () => {
  const [selectedVoice, setSelectedVoice] = useState<PrayerVoice>(PRAYER_VOICES[0]);

  return {
    selectedVoice,
    setSelectedVoice,
    PRAYER_VOICES
  };
};
